import { useSearchParams } from "react-router-dom";
import WalletRequestFlow from "@/features/wallets/wallet-request";
import { resolveWalletRequestStep } from "@/features/wallets/wallet-request-step";

export default function WalletNewPage(){
  const [searchParams] = useSearchParams();
  const { step, id } = Object.fromEntries(searchParams.entries());
  return <WalletRequestFlow initialStep={resolveWalletRequestStep(step)} viewId={step === "created" ? id : undefined} />;
}
